import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

/**
 * Lecture d'un contenu TEXTE rédigé (HTML déjà assaini côté serveur).
 * DOMPurify est appliqué ici en défense en profondeur. Bouton « Télécharger »
 * = fichier .html (le contenu exact), sans dépendance serveur.
 *
 * NB : nommé `HtmlTexteViewerModal` (et non `HtmlViewerModal`) parce qu'un
 * composant `ui/HtmlViewerModal.jsx` existe déjà — c'est la visionneuse
 * iframe de la Carte d'eau. Celui-ci lui est DISTINCT : il rend un fragment
 * HTML assaini via DOMPurify, avec un bouton « Télécharger ».
 */
const HtmlTexteViewerModal = ({ html, filename = 'document.html', onClose }) => {
  const propre = useMemo(
    () => DOMPurify.sanitize(html || '', { USE_PROFILES: { html: true } }),
    [html],
  );

  const telecharger = () => {
    const doc = `<!doctype html><meta charset="utf-8"><body>${propre}</body>`;
    const blob = new Blob([doc], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  };

  const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 1000010, display: 'flex', flexDirection: 'column' };
  const header = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.6rem 1rem', background: '#1f2937', color: 'white', flex: '0 0 auto' };
  const body = { flex: '1 1 auto', overflowY: 'auto', padding: '24px', background: '#374151' };
  const feuille = { maxWidth: 820, margin: '0 auto', background: 'white', color: '#111827', padding: '32px 40px', borderRadius: 8, lineHeight: 1.6 };
  const btn = { background: 'none', border: '1px solid rgba(255,255,255,0.5)', color: 'white', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: '0.85rem' };

  return (
    <div style={overlay} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={header}>
        <span style={{ fontSize: '0.9rem', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>📄 {filename}</span>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={btn} onClick={telecharger}>⬇︎ Télécharger</button>
          <button style={btn} onClick={onClose}>✕ Fermer</button>
        </div>
      </div>
      <div style={body}>
        <div style={feuille} className="doc-html-rendu" dangerouslySetInnerHTML={{ __html: propre }} />
      </div>
    </div>
  );
};

export default HtmlTexteViewerModal;
